import type { HelpFile } from '../../types/help'
import { ConnectorLogViewTestIds } from '../../../testids/ConnectorLogViewTestIds'

export const connectorLogViewHelp: HelpFile = {
  docPage: '/docs/systems/connectors',
  texts: {
    [ConnectorLogViewTestIds.cardTitleRecentActivity]: 'Recent connector activity — provisioning calls, sync operations, and their outcomes.',
    [ConnectorLogViewTestIds.btnRefreshLogs]: null,
    [ConnectorLogViewTestIds.colDuration]: null,
    [ConnectorLogViewTestIds.colOperation]: 'Type of operation (provision, deprovision, sync, etc.).',
    [ConnectorLogViewTestIds.colStatus]: null,
    [ConnectorLogViewTestIds.colTimestamp]: null,
  },
}
